module.exports = __webpack_public_path__ + "img/8.1389dd96.jpeg";